import { useEffect } from 'react'
import { useTenantSettings } from 'react-common'

// this hook is for Acronis brand spesific
export const useSetAcronisBodyClass = (className: string) => {
  const theme = useTenantSettings('platform.branding.theme') as 'default' | 'acronis'

  useEffect(() => {
    if (!className) {
      return
    }

    document.body.classList.add(className)

    return () => {
      document.body.classList.remove(className)
    }
  }, [className, theme])
}
